// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1hnGz","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1udWz","obliqueLine":"membershipbadge_obliqueLine__2UKTh"};